// ==============================|| OVERRIDES - TABS ||============================== //

export default function FormControl() {
  return {
    MuiFormControl: {
      styleOverrides: {
        roots:{
          gap:'6px'
        }
      }
    }
  };
}
